import axios from "../utils/axios.wrapper";

export const getVatSituations = async () => {
  const { data } = await axios.get("/VatSituation/active");
  return data.items || data;
};

export const getVatSituationById = async (id) => {
  const { data } = await axios.get(`/VatSituation/${id}`);
  return data;
};

export const createVatSituation = async (vatSituation) => {
  const { data } = await axios.post("/VatSituation/create", vatSituation);
  return data;
};

export const updateVatSituation = async (id, vatSituation) => {
  const { data } = await axios.put(`/VatSituation/${id}`, vatSituation);
  return data;
};

export const deleteVatSituation = async (id) => {
  const { data } = await axios.delete(`/VatSituation/${id}`);
  return data;
};

export const vatSituationsService = {
  getVatSituations,
  getVatSituationById,
  createVatSituation,
  updateVatSituation,
  deleteVatSituation,
};